import { useEffect, useState } from 'react';
import { ExtractValueFromConfig, UseBroadcastValueConfig } from 'types';

/** for consumer components to read a value broadcasted from another tab */
export const useBroadcastedValue = <T extends UseBroadcastValueConfig>({
  channel,
  event,
  initialValue,
}: T) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    const broadcastChannel = new BroadcastChannel(channel);

    // Receive messages and set the value in state if they match the type.
    broadcastChannel.onmessage = (ev) => {
      ev.data.type === event && setValue(ev.data.value);
    };

    // Close the channel -- we no longer want to receive messages
    return () => {
      broadcastChannel.close();
    };
  }, [channel, event]);

  return value as ExtractValueFromConfig<T>;
};
